import { render } from "./User_Authorizations.vue?vue&type=template&id=095db4a1"
import script from "./User_Authorizations.vue?vue&type=script&lang=js"
export * from "./User_Authorizations.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__